export default __webpack_public_path__ + "f2cb874ba5f2509d127c33d980063add.jpg";